import {Icon} from '@wandb/components';
import React from 'react';

export interface WBAgentNetworkDomainListProps {
  domains: string[];
  /** Which domains are currently selected (checked). */
  selected: Record<string, boolean>;
  onToggle: (domain: string) => void;
}

/**
 * WBAgentNetworkDomainList renders a list of toggleable domain rows, shared by
 * the grant request card and the manage/revoke view. The list caps its height
 * and scrolls so a long set of domains never pushes the surrounding controls
 * (reason text, action buttons) off-screen.
 */
export const WBAgentNetworkDomainList = ({
  domains,
  selected,
  onToggle,
}: WBAgentNetworkDomainListProps) => (
  <div className="flex max-h-[240px] flex-col gap-4 overflow-y-auto">
    {domains.map(domain => {
      const isSelected = !!selected[domain];
      return (
        <button
          key={domain}
          type="button"
          aria-pressed={isSelected}
          onClick={() => onToggle(domain)}
          className={`flex w-full items-center gap-8 rounded-md border px-12 py-8 text-left text-sm transition-colors ${
            isSelected
              ? 'border-[var(--teal-450)] dark:border-wb-accent-hover bg-[color-mix(in_srgb,var(--teal-300)_48%,transparent)] dark:bg-wb-accent-bg text-wb-accent-text'
              : 'border-wb-border bg-wb-surface text-wb-text-primary hover:bg-moon-100 dark:hover:bg-wb-surface-sunken'
          }`}>
          <span className="inline-flex shrink-0">
            <Icon
              icon={isSelected ? 'checkmark' : 'add-new'}
              size="sm"
              color={isSelected ? 'teal' : 'moon'}
            />
          </span>
          <span className="break-all font-[Inconsolata]">{domain}</span>
        </button>
      );
    })}
  </div>
);
